import { Link } from "react-router-dom";
import { formatPlayCount } from "@/utils/video";

export interface VideoCardData {
  id: string;
  title: string;
  cover: string;
  categoryName: string;
  duration: string;
  publishDate: string;
  playCount: number;
  score: number;
}

interface VideoCardProps {
  video: VideoCardData;
  index?: number;
}

export default function VideoCard({ video, index = 0 }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <div className="relative aspect-video w-full overflow-hidden rounded-lg bg-secondary-100">
        <img
          src={video.cover}
          alt={`${video.title} 视频封面`}
          title={`${video.title} - 色色视频`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 flex items-center justify-center bg-foreground-950/0 transition-colors group-hover:bg-foreground-950/30">
          <span className="flex h-12 w-12 scale-90 items-center justify-center rounded-full bg-primary-500/90 text-background-50 opacity-0 transition-all group-hover:scale-100 group-hover:opacity-100">
            <i className="ri-play-fill text-2xl" aria-hidden="true"></i>
          </span>
        </div>
        <span className="absolute bottom-2 right-2 rounded-md bg-foreground-950/75 px-2 py-0.5 text-xs font-medium text-background-50">
          {video.duration}
        </span>
        <span className="absolute left-2 top-2 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-medium text-background-50">
          {video.categoryName}
        </span>
      </div>
      <h3 className="mt-3 line-clamp-2 text-sm font-medium leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
        {video.title}
      </h3>
      <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500">
        <span className="flex items-center gap-1">
          <i className="ri-play-circle-line text-sm" aria-hidden="true"></i>
          {formatPlayCount(video.playCount)}
        </span>
        <span className="flex items-center gap-1 text-accent-600">
          <i className="ri-star-fill text-sm" aria-hidden="true"></i>
          {video.score.toFixed(1)}
        </span>
        <span className="whitespace-nowrap">{video.publishDate}</span>
      </div>
    </Link>
  );
}